import { mapState } from "vuex";

/** Сумма по cart.products vs min_amount_for_delivery — адрес, карта, слот доставки */
export default {
  computed: {
    ...mapState({
      cartProducts: (state) => state.cart.products,
      minAmountForDelivery: (state) => state.cart.minAmountForDelivery,
    }),
    sumCartProducts() {
      return (this.cartProducts || []).reduce(
        (sum, p) => sum + (Number(p.amount) || 0),
        0
      );
    },
    showDeliveryZonesMap() {
      const min = this.minAmountForDelivery;
      if (min == null || min <= 0) {
        return true;
      }
      return this.sumCartProducts >= min;
    },
  },
};
